import { render, staticRenderFns } from "./GearRatioChart.vue?vue&type=template&id=07d7df47&scoped=true&"
import script from "./GearRatioChart.vue?vue&type=script&lang=js&"
export * from "./GearRatioChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d7df47",
  null
  
)

export default component.exports